/**
 * `/app/widgets/$widgetRef/posts` — a blog's posts, for the client
 * (`.docs/46-blog-and-forms.md` §7). The page is `pages/blog/PostsPage.tsx`, the one
 * the studio mounts too; this file is the address, and `ClientBlog` is the client's door
 * into it (the role, the widget, the REST port).
 *
 * `?phase=` and `?q=` are the page's own, declared here so the router keeps them across
 * a navigation, through `routeSearch` so a value somebody typed falls back to every post
 * rather than to an error page. A `$widgetRef` that is not a widget reference names
 * nothing and is a not-found; one that is, but is not this client's blog, is the page's
 * own one line.
 */

import { isRef } from '@fareast/shared'
import { createFileRoute, notFound } from '@tanstack/react-router'

import { NotFound } from '../../../../../errors/NotFound.js'
import { PostsPage } from '../../../../../pages/blog/PostsPage.js'
import { parsePostsSearch } from '../../../../../pages/blog/search.js'
import { ClientBlog } from '../../../../../pages/client/blog/ClientBlog.js'

export const Route = createFileRoute('/app/widgets/$widgetRef/posts/')({
  beforeLoad: ({ params }) => {
    if (!isRef('widget', params.widgetRef)) throw notFound()
  },
  validateSearch: parsePostsSearch,
  /** R3-13: a refusal under this route keeps the portal around it. */
  notFoundComponent: NotFound,
  component: PostsRoute,
})

function PostsRoute() {
  const { widgetRef } = Route.useParams()
  return (
    <ClientBlog widgetRef={widgetRef}>
      <PostsPage />
    </ClientBlog>
  )
}
